import axios from "axios";
import { aliasPlatform } from "../../../utils/helper";

interface IWebsiteParams {
  step_code: 0 | 1;
  platform: string;
}
interface IParams {
  newStatus: boolean;
  platform: string;
}

export async function updateRetailWebsiteStatus({
  step_code,
  platform,
}: IWebsiteParams) {
  const body = {
    is_active: !!step_code,
  };
  const shortPl = aliasPlatform(platform);
  const res = await axios.put(
    `api/v2/merchants/branch/active`,
    body
  );
  return res.data;
}

export async function activeWebsite({
  merchantId,
  branchId,
  platform = "retail",
}: any) {
  // const body = {
  //   is_install: true,
  // };
  // const res = await axios.put(
  //   "/api/v1/retail/branch/update-is-install",
  //   body
  // );
  // return res.data;

  const body = {
    merchant_id: merchantId,
    branch_id: branchId,
    platform: platform,
  };
  const shortPl = aliasPlatform(platform);
  const url = `api/v1/${shortPl}/merchant/active-website`;

  const res = await axios.post(url, body);
  return res.data;
}

export async function updateSyncStatus({ newStatus, platform }: IParams) {
  const body = {
    is_syncing: newStatus,
  };
  const shortPl = aliasPlatform(platform);
  const res = await axios.put(
    `api/v1/${shortPl}/branch/update-is-syncing`,
    body
  );
  return res.data;
}
export async function updateSyncStatusOnboard({
  is_onboarding,
  platform,
}: {
  is_onboarding: boolean;
  platform: string;
}) {
  const body = {
    is_onboarding: is_onboarding,
  };
  const shortPl = aliasPlatform(platform);
  return axios.put(`api/v1/${shortPl}/branch/onboarding`, body);
}

export async function updateActiveWebsite({
  is_active,
  platform,
}: {
  is_active: boolean;
  platform: string;
}) {
  const body = {
    is_active: is_active,
  };
  const shortPl = aliasPlatform(platform);
  const res = await axios.put(
    `api/v2/merchants/branch/active`,
    body
  );
  return res.data;
}
